type Listener = () => void;

/**
 * A helper that can be used to create a primitive store for
 * `useSyncExternalStore`. To be used when there is no async data to manage,
 * but the data in the store is "global" to the app.
 *
 * Essentially just a generalized version of the `todosStore` in the official
 * [React docs](https://react.dev/reference/react/useSyncExternalStore#subscribing-to-an-external-store).
 */
export function createDummyStore() {
  let listeners: readonly Listener[] = [];

  function emitChange() {
    for (let listener of listeners) {
      listener();
    }
  }

  function subscribe(listener: Listener) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  }

  return { emitChange, subscribe };
}
